import React, { useContext, useEffect } from 'react'
import { toast } from 'react-toastify'
import { ToastContainer } from 'react-toastify'
import AlertContext from '@/product/context/alert/alertContext'
import { useTranslation } from 'react-i18next'
import 'react-toastify/dist/ReactToastify.css'

const Alerts = () => {
    const alertContext = useContext(AlertContext)
    const { alerts, clearAlert } = alertContext
    const { t } = useTranslation()

    const autoClose = 5000

    const customToastMessageColors = {
        default: {
            backgroundColor: '#696880',
            color: 'white',
        },
        info: {
            backgroundColor: '#696880',
            color: 'white',
        },
        success: {
            backgroundColor: '#696880',
            color: 'white',
        },
        warning: {
            backgroundColor: '#696880',
            color: 'white',
        },
        error: {
            backgroundColor: '#696880',
            color: 'white',
        },
        gold: {
            backgroundColor: '#d8b578',
            color: 'black',
        },
    }

    useEffect(() => {
        alerts.forEach((alert) => {
            const style = customToastMessageColors[alert.type] || {}

            toast(t(alert.msg), {
                position: 'bottom-right',
                autoClose: autoClose,
                hideProgressBar: true,
                newestOnTop: true,
                closeOnClick: true,
                rtl: false,
                pauseOnFocusLoss: true,
                draggable: true,
                pauseOnHover: true,
                type: alert.type,
                style: style || {},
                progress: false,
                icon: false,
            })

            clearAlert(alert.id)
        })
    }, [alerts, clearAlert])

    return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={autoClose}
                hideProgressBar={true}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                progres={false}
                icon={false}
            />
        </>
    )
}

export default Alerts
